import React, { useContext, useEffect, useState } from 'react';
import { useUrlContext } from '../context/urlContext';
import { errorContext } from "../Components/ErrorDisplay";
import { useConfirm } from "../Components/ConfirmDialog";
import ParentComponent from "../Components/ParentForTableAndFormComponent";
import axios from "axios";
import S7000ConfigForm from "../Forms/S7000ConfigForm";
import { useAuth } from '../context/authContext';
import { Typography } from '@mui/material';

export default function S7000Config(props) {
    const { UrlHelperObj } = useUrlContext();
    const { user } = useAuth();
    const confirm = useConfirm();
    const [columnInfo] = useState([
        { title: 'Reg Code', dbname: 'reg_code' },
        { title: 'User', dbname: 'user' },
        { title: 'URL', dbname: 'URL' },
        { title: 'Frequency', dbname: 'frequency_display' }
    ]);
    const [s7000Records, setS7000Records] = useState([]);
    // Only one S7000 configuration is allowed per club (iId).
    const hasExistingConfig = s7000Records.length >= 1;
    const { handleError, notify } = useContext(errorContext);
    const [formShown, setFormShown] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);

    useEffect(() => {
        if (user?.issuerId) {
            getS7000Records();
        }
    }, [user?.issuerId]);

    async function getS7000Records() {
        await axios.get(UrlHelperObj.s7000Url_GET(user.issuerId))
            .then(response => {
                console.log("Received S7000 configuration:", response.data);
                return response.data;
            })
            .then(results => {
                let records = [];
                if (Array.isArray(results)) {
                    records = results;
                } else if (results && Array.isArray(results.data)) {
                    records = results.data;
                } else if (results && typeof results === 'object' && Object.keys(results).length > 0) {
                    if (results.reg_code !== undefined || results.URL !== undefined) {
                        records = [results];
                    } else if (results.data && typeof results.data === 'object') {
                        records = [results.data];
                    }
                }
                const freqMap = { 0: 'Daily', 1: 'Hourly', 2: 'Weekly' };
                const processed = records.map((r, index) => ({
                    ...r,
                    id: r.id || `s7000-${index}`,
                    frequency_display: freqMap[Number(r.frequency)] ?? r.frequency
                }));
                setS7000Records(processed);
                // Empty result: notify the user (red, to match the other list pages).
                if (processed.length === 0) {
                    notify('No records found', 'error');
                }
            })
            .catch(err => handleError(err));
    }

    async function deleteS7000Record(record) {
        const ok = await confirm({ title: 'Delete configuration', message: 'Delete this S7000 configuration?', confirmText: 'Delete' });
        if (!ok) {
            return;
        }
        await axios.delete(UrlHelperObj.s7000Url_GET(user.issuerId))
            .then(response => response.data)
            .then(results => console.log("Delete of S7000 record successful"))
            .catch(err => handleError(err));
        getS7000Records();
    }

    async function editS7000Record(record) {
        const data = {
            reg_code: record.reg_code,
            user: record.user,
            webpass: record.webpass,
            issuer_id: user.issuerId,
            URL: record.URL,
            frequency: record.frequency
        };

        await axios.put(UrlHelperObj.s7000Url(), data)
            .then(response => response.data)
            .then(results => console.log("Edit of S7000 record successful"))
            .catch(err => handleError(err));
        getS7000Records();
    }

    async function addS7000Record(record) {
        const data = {
            reg_code: record.reg_code,
            user: record.user,
            webpass: record.webpass,
            issuer_id: user.issuerId,
            URL: record.URL,
            frequency: record.frequency
        };

        await axios.post(UrlHelperObj.s7000Url(), data)
            .then(response => response.data)
            .then(results => console.log("Add of S7000 record successful"))
            .catch(err => handleError(err));
        getS7000Records();
    }

    function handleFormSubmit(data, isAddOperation, isCancelOperation) {
        setFormShown(false);
        if (isCancelOperation) {
            return;
        }
        if (isAddOperation) {
            addS7000Record(data);
        } else {
            editS7000Record(data);
        }
    }

    return (
        <>
        {hasExistingConfig && !formShown && (
            <Typography style={{ color: '#b26a00', marginBottom: 8, textAlign: 'left' }}>
                Only one S7000 configuration is allowed per club. Edit the existing one, or delete it to create a new one.
            </Typography>
        )}
        <ParentComponent
            data={s7000Records}
            columns={columnInfo}
            form={S7000ConfigForm}
            formTitle={"S7000 Configuration"}
            handleFormSubmitFunc={handleFormSubmit}
            setFormShownFlag={setFormShown}
            alreadySelectedOwnRow={selectedRow}
            deleteFunc={deleteS7000Record}
            setSelectedRow={setSelectedRow}
            isAddDisabled={hasExistingConfig}
        />
        </>
    );
}
